import {Deserializable} from './deserializable';
import {parse} from 'date-fns';


export class BaseModel implements Deserializable {
  
  id: number;
  createdAt: Date;
  updateAt: Date;

  deserialize(input: any) {
    
    Object.assign(this, input);
    if (!input) {
      return this;
    }

    this.createdAt = parse(input.createdAt);
    this.updateAt = parse(input.updateAt);
    return this;
  }
}
